import React, { useState } from "react";
import { Heading } from "../common/Heading";
import { portfolio } from "../data/dummydata";

export const Portfolio = ({ language }) => {
  const [list] = useState(portfolio);

  return (
    <>
      <article className="port-container">
       
          <Heading title={language !== false ? "Portfolio" : "Portafolio"} />
          <div className="content grid3">
            {list.map((item, i) => (
              <div key={i} className="box" data-aos="fade-up">
                <div className="img">
                  <img src={item.cover} alt="" />
                </div>
                <div className="overlay">
                  <h3>{item.title}</h3>
                  <span>{item.name}</span>
                  <div className="portfolio-icons">
                    {item.url && (
                      <a
                        href={item.url}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {" "}
                        <i className="fa-brands fa-github"></i>
                      </a>
                    )}
                    <a
                      href={item.show}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      <i className="fa-solid fa-arrow-up-right-from-square"></i>
                    </a>
                  </div>
                </div>
              </div>
            ))}
         
        </div>
      </article>
    </>
  );
};
